module.exports = __webpack_public_path__ + "static/media/wi-owm-602.e6d81fcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather-svg/wi-owm-602.svg
// module id = 821
// module chunks = 0